import { render, staticRenderFns } from "./ResponsiveVideoImage.vue?vue&type=template&id=cdb66410&"
import script from "./ResponsiveVideoImage.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveVideoImage.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveVideoImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports